import {Input, Tooltip} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import React, {useState, useCallback} from "react";

const SearchInput = ({
    tooltip,
    onSearch,
    onEnter,
    placeholder = "Ara...",
    enterButton = true,
    allowClear = true
}) => {
    const [searchValue, setSearchValue] = useState("");

    const handleSearch = useCallback(() => {
        const searchCallback = onEnter || onSearch;
        if (searchCallback) {
            searchCallback(searchValue);
        }
    }, [searchValue, onEnter, onSearch]);

    return (
        <Tooltip title={tooltip}>
            <Input.Search
                placeholder={placeholder.toString()}
                prefix={<SearchOutlined />}
                value={searchValue}
                onChange={e => setSearchValue(e.target.value)}
                onSearch={handleSearch}
                enterButton={enterButton}
                allowClear={allowClear}
                style={{width: "100%", minWidth: 150, maxWidth: 220}}
            />
        </Tooltip>
    );
};

export default SearchInput;
